export const normalizeUppercase = (value: string) => value && value.toUpperCase()
